import React, { useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import { CheckmarkOutline, ReloadOutline, SaveOutline } from 'react-ionicons';

const ButtonSave = ({ onClick = null, status = 1, setStatus = null, text = 'Guardar', variant = 'primary', icon = SaveOutline }) => {


    useEffect(() => {
        if (status === 3) {
            const timeout = setTimeout(() => {
                if (setStatus) {
                    setStatus(1);
                }
            }, 2000);

            return () => clearTimeout(timeout);
        }
    }, [status]);


    const handleButtonClick = () => {
        if (status === 1) {
            if (setStatus) {
                setStatus(2);
            }
            if (onClick) {
                onClick();
            }
        }
    };

    let buttonText = '';
    let _icon = null;
    let variantColor = variant;


    if (status === 1 || status === 0) {
        buttonText = text;
        //_icon = <IonIcon icon={currentIcon} className='mr-0 ml-1' />;
        _icon = <SaveOutline color="#fff" width="20px" height="20px" />
    } else if (status === 2) {
        buttonText = 'Espere';
        //_icon = <IonIcon icon={loader} className="spin mr-0 ml-1" />;
        _icon = <ReloadOutline color="#fff" width="20px" height="20px" rotate />;
    } else if (status === 3) {
        buttonText = 'Éxito';
        //_icon = <IonIcon icon={checkmarkOutline} className='mr-0 ml-1' />;
        _icon = <CheckmarkOutline color="#fff" width="20px" height="20px" />
        variantColor = 'success';
    } else {
        _icon = icon
    }

    return (
        <Button variant={variantColor} onClick={handleButtonClick} disabled={status === 2 || status === 0}>
            {buttonText} <span className='ms-2'></span> {_icon}
        </Button>
    );
};

export default ButtonSave;
